// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainarea-assessment {
  display: flex;
  padding-bottom: 1.5rem; 
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0;
  align-self: stretch;
  width: 100%;
}

.header-assessment {
  display: flex;
  position: fixed;
  height: 4.5rem;
  align-items: center;
  gap: 0.5rem; /* 8px */
  align-self: stretch;
  width: 100%;
 
}

.main {
  padding-left:  2.5rem;
  width: 60vw;
}

.assessment {
  display: flex;
  padding-top: 5.5rem;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  flex: 1 0;
  align-self: stretch;
}

.blog-post-card {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  align-self: stretch;
}

.blog-post-card1 {
  display: flex;
  width: 45%;
  padding: 1.5rem 1.5rem 2rem 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  border-radius: 0.5rem;
  border: 1px solid var(--Neutral-300, #cbd5e1);
  background: var(--White, #fff);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.assessment-img {
  height: 25vh;
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
  background: lightgray 0px -29.789px / 100% 186.047% no-repeat;
}

.content-ass {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  align-self: stretch;
}

.heading-and-subheading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
}

.heading-and-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
}
.blog-content-post {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}
.heading-icon {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
}
.heading-text {
  flex: 1 0;
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2rem; /* 160% */
}

.icon-wrap {
  display: flex;
  width: 1.5rem;
  height: 1.75rem;
  padding-top: 0.25rem;
  flex-direction: column;
  align-items: flex-start;
}

.heading-subtitle {
  align-self: stretch;
  color: var(--Neutral-700, #334155);
  font-family: Inter;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 150% */
}
.btn-start-refection {
  display: flex;
  height: 2.625rem; /* 42px */
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem; /* 8px */
  border-radius: 0.25rem; /* 4px */
  border: 0.03125rem solid #0a5b42; /* 0.5px */
  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);

  margin-top: auto;
}

.btn-start-refection:hover {
  background: linear-gradient(180deg, #096d4c 0%, #06412f 103.57%);
}
.btn-text {
  color: #f8fafc;
  text-align: center;
  font-family: Inter;
  font-size: var(--Label-Large-Size, 0.875rem); /* 14px */
  font-style: normal;
  font-weight: 500;
  line-height: var(--Label-Large-Line-Height, 1.25rem); /* 20px */
  letter-spacing: var(--Label-Large-Tracking, 0.00625rem); /* 0.1px */
}

.arrow {
  width: 2rem; /* 32px */
  height: 2rem; /* 32px */
  aspect-ratio: 1 / 1;
}

.blog-article-content {
  display: flex;
  padding: 1.5rem 0rem; /* 24px 0px */
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem; /* 16px */
  flex: 1 0;
  align-self: stretch;
  border-top: 1px solid var(--Neutral-300, #cbd5e1);
}

.blog-article-session {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5rem; /* 8px */
  align-self: stretch;
}

.blog-article-content1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 0.5rem; /* 8px */
}

.subheading-container {
  display: flex;
  padding: 1rem 0.5rem; /* 16px 8px */
  justify-content: center;
  align-items: center;
  gap: 0.5rem; /* 8px */
  border-radius: 0.25rem; /* 4px */
  background: var(--Primary-100, #d3f8e4);
}

.Subheading {
  color: var(--Primary-700, #0a7253);
  font-family: Inter;
  font-size: 0.75rem; /* 12px */
  font-style: normal;
  font-weight: 600;
  line-height: 0.5rem; /* 8px */
}

.blog-article-title {
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 1rem; /* 16px */
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem; /* 24px */
}

.blog-article-description {
  color: var(--Neutral-500, #64748b);
  font-family: Inter;
  font-size: 0.75rem; /* 12px */
  font-style: normal;
  font-weight: 400;
  line-height: 1rem; /* 16px */
}

@media (max-width: 1040px) {
  .blog-post-card {
    flex-direction: column;
    align-items: center;
  }

  .blog-post-card1 {
    max-width: 100%;
    width: 100%;
  }
  .assessment-img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}

@media (max-width: 480px) {
  .blog-post-card {
    flex-direction: column;
    align-items: center;
    width:84vw;
  }
  .heading-subtitle{
    font-size: 12px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/MainContentArea/MainContent.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW,EAAE,QAAQ;EACrB,mBAAmB;EACnB,WAAW;;AAEb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,SAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,6CAA6C;EAC7C,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;AACA;EACE,aAAa;EACb,gBAAgB,EAAE,SAAS;EAC3B,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,QAAQ;EACrB,sBAAsB,EAAE,QAAQ;EAChC,gCAAgC,EAAE,UAAU;EAC5C,gEAAgE;;EAEhE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;AAClE;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C,EAAE,SAAS;EACvD,kBAAkB;EAClB,gBAAgB;EAChB,oDAAoD,EAAE,SAAS;EAC/D,uDAAuD,EAAE,UAAU;AACrE;;AAEA;EACE,WAAW,EAAE,SAAS;EACtB,YAAY,EAAE,SAAS;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB,EAAE,aAAa;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,SAAS,EAAE,SAAS;EACpB,SAAW;EACX,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW,EAAE,QAAQ;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,WAAW,EAAE,QAAQ;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB,EAAE,aAAa;EACnC,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,QAAQ;EACrB,sBAAsB,EAAE,QAAQ;EAChC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,QAAQ;AAC/B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe,EAAE,SAAS;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".mainarea-assessment {\n  display: flex;\n  padding-bottom: 1.5rem; \n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 0 0;\n  align-self: stretch;\n  width: 100%;\n}\n\n.header-assessment {\n  display: flex;\n  position: fixed;\n  height: 4.5rem;\n  align-items: center;\n  gap: 0.5rem; /* 8px */\n  align-self: stretch;\n  width: 100%;\n \n}\n\n.main {\n  padding-left:  2.5rem;\n  width: 60vw;\n}\n\n.assessment {\n  display: flex;\n  padding-top: 5.5rem;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.blog-post-card {\n  display: flex;\n  align-items: stretch;\n  gap: 1rem;\n  align-self: stretch;\n}\n\n.blog-post-card1 {\n  display: flex;\n  width: 45%;\n  padding: 1.5rem 1.5rem 2rem 1.5rem;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--Neutral-300, #cbd5e1);\n  background: var(--White, #fff);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.assessment-img {\n  height: 25vh;\n  width: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n  background: lightgray 0px -29.789px / 100% 186.047% no-repeat;\n}\n\n.content-ass {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2rem;\n  align-self: stretch;\n}\n\n.heading-and-subheading {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  align-self: stretch;\n}\n\n.heading-and-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  align-self: stretch;\n}\n.blog-content-post {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n  align-self: stretch;\n}\n.heading-icon {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  align-self: stretch;\n}\n.heading-text {\n  flex: 1 0 0;\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 1.25rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 2rem; /* 160% */\n}\n\n.icon-wrap {\n  display: flex;\n  width: 1.5rem;\n  height: 1.75rem;\n  padding-top: 0.25rem;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.heading-subtitle {\n  align-self: stretch;\n  color: var(--Neutral-700, #334155);\n  font-family: Inter;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem; /* 150% */\n}\n.btn-start-refection {\n  display: flex;\n  height: 2.625rem; /* 42px */\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem; /* 8px */\n  border-radius: 0.25rem; /* 4px */\n  border: 0.03125rem solid #0a5b42; /* 0.5px */\n  background: linear-gradient(180deg, #0c8f63 0%, #0a7253 103.57%);\n\n  margin-top: auto;\n}\n\n.btn-start-refection:hover {\n  background: linear-gradient(180deg, #096d4c 0%, #06412f 103.57%);\n}\n.btn-text {\n  color: #f8fafc;\n  text-align: center;\n  font-family: Inter;\n  font-size: var(--Label-Large-Size, 0.875rem); /* 14px */\n  font-style: normal;\n  font-weight: 500;\n  line-height: var(--Label-Large-Line-Height, 1.25rem); /* 20px */\n  letter-spacing: var(--Label-Large-Tracking, 0.00625rem); /* 0.1px */\n}\n\n.arrow {\n  width: 2rem; /* 32px */\n  height: 2rem; /* 32px */\n  aspect-ratio: 1 / 1;\n}\n\n.blog-article-content {\n  display: flex;\n  padding: 1.5rem 0rem; /* 24px 0px */\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem; /* 16px */\n  flex: 1 0 0;\n  align-self: stretch;\n  border-top: 1px solid var(--Neutral-300, #cbd5e1);\n}\n\n.blog-article-session {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0.5rem; /* 8px */\n  align-self: stretch;\n}\n\n.blog-article-content1 {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 0.5rem; /* 8px */\n}\n\n.subheading-container {\n  display: flex;\n  padding: 1rem 0.5rem; /* 16px 8px */\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem; /* 8px */\n  border-radius: 0.25rem; /* 4px */\n  background: var(--Primary-100, #d3f8e4);\n}\n\n.Subheading {\n  color: var(--Primary-700, #0a7253);\n  font-family: Inter;\n  font-size: 0.75rem; /* 12px */\n  font-style: normal;\n  font-weight: 600;\n  line-height: 0.5rem; /* 8px */\n}\n\n.blog-article-title {\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 1rem; /* 16px */\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.5rem; /* 24px */\n}\n\n.blog-article-description {\n  color: var(--Neutral-500, #64748b);\n  font-family: Inter;\n  font-size: 0.75rem; /* 12px */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1rem; /* 16px */\n}\n\n@media (max-width: 1040px) {\n  .blog-post-card {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .blog-post-card1 {\n    max-width: 100%;\n    width: 100%;\n  }\n  .assessment-img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n}\n\n@media (max-width: 480px) {\n  .blog-post-card {\n    flex-direction: column;\n    align-items: center;\n    width:84vw;\n  }\n  .heading-subtitle{\n    font-size: 12px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
